if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      showLoadingState() {
        const defaultText = this.submitButton.querySelector('.atc-default-text');
        const loadingText = this.submitButton.querySelector('.atc-loading-text');
        const successText = this.submitButton.querySelector('.atc-success-text');
        
        if (defaultText) defaultText.classList.add('atc-hidden');
        if (loadingText) loadingText.classList.remove('atc-hidden');
        if (successText) successText.classList.add('atc-hidden');
        
        console.log('Loading state activated');
      }

      showSuccessState() {
        const defaultText = this.submitButton.querySelector('.atc-default-text');
        const loadingText = this.submitButton.querySelector('.atc-loading-text');
        const successText = this.submitButton.querySelector('.atc-success-text');
        
        if (defaultText) defaultText.classList.add('atc-hidden');
        if (loadingText) loadingText.classList.add('atc-hidden');
        if (successText) successText.classList.remove('atc-hidden');
        
        console.log('Success state activated');
      }

      showDefaultState() {
        const defaultText = this.submitButton.querySelector('.atc-default-text');
        const loadingText = this.submitButton.querySelector('.atc-loading-text');
        const successText = this.submitButton.querySelector('.atc-success-text');
        
        if (defaultText) defaultText.classList.remove('atc-hidden');
        if (loadingText) loadingText.classList.add('atc-hidden');
        if (successText) successText.classList.add('atc-hidden');
        
        console.log('Default state activated');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        
        // Show loading state
        this.showLoadingState();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              this.showDefaultState();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            
            // Show success state immediately
            this.showSuccessState();

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }

            // Reset to default state after 2.5 seconds
            setTimeout(() => {
              this.showDefaultState();
              this.submitButton.removeAttribute('aria-disabled');
            }, 2500);
          })
          .catch((e) => {
            console.error(e);
            this.showDefaultState();
            this.submitButton.removeAttribute('aria-disabled');
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}